"use client";

import { Toaster as Sonner, toast } from "sonner";

export function Toaster() {
  return (
    <Sonner
      position="top-center"
      toastOptions={{
        className: "!bg-card !text-ink !border !border-line !shadow-card !rounded-[12px]",
      }}
    />
  );
}

export { toast };
